import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import SimpleTable from '../../../components/commons/general/SimpleTable'

export default connect(null, null)(translate()(SimpleTable))
